/**
 * Cache API
 */

import { CacheStats } from '../types/api';
import { getAPIClient } from './client';

export async function getCacheStats(projectId: string): Promise<CacheStats> {
  const client = getAPIClient();
  return client.get<CacheStats>(`/cache/stats/${projectId}`);
}

export async function clearCache(projectId: string): Promise<{ cleared: number }> {
  const client = getAPIClient();
  return client.delete<{ cleared: number }>(`/cache/${projectId}`);
}

export async function getPerformanceStats(projectId: string): Promise<any> {
  const client = getAPIClient();
  return client.get(`/cache/performance/${projectId}`);
}


